import { useState } from 'react'
import { Button_Main } from '../components/Button'
import Pagenation from '../components/Pagenation'
import Table from '../components/Table'
import { Main } from '../styles/layout'
import { Table_Info } from '../styles/table'
import { useGetActivity, useGetActivityExcel } from '../api/main'
import { useLocation } from 'react-router'
import SearchForm, { DefaultParamKeys } from '../components/Search'
import { useAuthCheck } from '../hook'
import { theme } from '../styles/theme'

const getExcelParam = (search:string) => {
  const queryParams = new URLSearchParams(search)
  queryParams.delete('pageNo')
  queryParams.delete('pageSize')
  return `?${queryParams.toString()}`
}

const Activity = () => {
  const location = useLocation()
  const { checkAuth } = useAuthCheck()
  const { data, isLoading, isError } = useGetActivity(location.search)
  const { refetch: getExcelUrl } = useGetActivityExcel(getExcelParam(location.search),{
    staleTime: 0,
    enabled: false, 
  })
  const [isState, setIsState] = useState('Ready')


  const getExcel = async () => {
    if (isState === 'Loading') return
    try {
      setIsState('Loading')
      const excelData = await getExcelUrl()
      getDownload(excelData.data)
      setIsState('isSuccess')
      setTimeout(()=>{setIsState('Ready')},2000)
    } catch (error: unknown) {
      setIsState('isError')
      setTimeout(()=>{setIsState('Ready')},2000)
      //useModalApiError(error,setErrorMsg)
    }
  }

  const getDownload = (data:Blob) => {
    const filename = `관리자이력_${getCurrentTimestamp()}.xlsx`;
    const blob = new Blob([data], { type: 'application/zip' });
    // Blob 객체를 가리키는 URL 생성
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    // 링크 제거 및 URL 해제
    if(link.parentNode){
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }

  const getCurrentTimestamp = () => {
    const now = new Date();
    
    // 원하는 포맷으로 날짜와 시간 생성 (YYYY-MM-DD_HH-mm-SS)
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
  
    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
  };

  return (
    <Main>
      <h1>사용 이력</h1>
      {checkAuth('1100') && <SearchForm searchList={searchList}/>}
      <Table_Info>
        Total Count: {data?.total}
        {isState === 'isSuccess' && <Button_Main $bgColor={theme.colors.blue}>다운로드 성공</Button_Main>}
        {isState === 'isError' && <Button_Main $bgColor={theme.colors.red}>다운로드 실패</Button_Main>}
        {(isState === 'Ready' || isState === 'Loading') && <Button_Main onClick={getExcel} $isLoading={isState === 'Loading'}>액셀</Button_Main>}
      </Table_Info>
      <Table headers={headers} data={data?.data} isLoading={isLoading} isError={isError} rowKey={'groupName'} modalKey={"groupId"}  rowBtn={''}/>
      <Pagenation totalPage={data?.totalPage} isLoading={isLoading}/>
    </Main>
  )
}

export default Activity

const headers = [
  { value: 'partName', label: '소속' },
  { value: 'groupName', label: '그룹' },
  { value: 'loginId', label: '아이디' },
  { value: 'userName', label: '관리자명' },
  { value: 'action', label: '활동' },
  { value: 'inDt', label: '이력일' }
]

const searchList:DefaultParamKeys[] = [
  'partName',
  'groupName'
]
